if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.quantityForm = this.querySelector('.product-form__quantity');
        this.loadingSpinner = this.querySelector('.quantity__rules-cart .loading__spinner');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input || !this.quantityForm) return;
        this.setQuantityBoundaries();

        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection || this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundaries();
        });
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
        this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
      }

      setQuantityBoundaries() {
        const data = {
          cartQuantity: parseInt(this.input.dataset.cartQuantity) || 0,
          min: parseInt(this.input.dataset.min) || 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: parseInt(this.input.step) || 1,
        };

        let min = data.min;
        const max = data.max !== null ? data.max - data.cartQuantity : null;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant?.value) return;
        this.loadingSpinner?.classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundaries();
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.loadingSpinner?.classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        selectors.forEach((selector) => {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) return;

          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            attributes.forEach((attribute) => {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            });
          } else {
            current.innerHTML = updated.innerHTML;
          }
        });
      }
    }
  );
}

class StickyProduct extends HTMLElement {
  constructor() {
    super();
    this.lastScrollTop = 0;
    this.stickyProductContainer = this.querySelector('.sticky__product');
    this.handleScroll = this.handleScroll.bind(this);
    this.button = this.querySelector('.sticky__product-add');

    this.button.addEventListener('click', function () {
      document.querySelector('.product-form__submit').click();
    });
  }

  connectedCallback() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    
    if (scrollTop > this.lastScrollTop) {
      this.stickyProductContainer?.classList.add('active');
    } else {
      /*this.stickyProductContainer?.classList.remove('active');*/
    }
    
    this.lastScrollTop = Math.max(0, scrollTop);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}

customElements.define('sticky-product', StickyProduct);

class QuantitySingle extends HTMLElement {
  constructor() {
    super();
    this.quantityCards = this.querySelectorAll('.product-quantity__card');
    this.variantInputs = document.querySelectorAll('input[data-image]');
    this.quantityInputs = document.querySelectorAll('.product-quantity');
    this.submitSpans = document.querySelectorAll('.product-form__submit span span');
    this.submitButtons = document.querySelectorAll('.product-form__submit');
    this.durationElements = document.querySelectorAll('.product-quantity__duration');

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCardClick = this.handleCardClick.bind(this);
  }

  connectedCallback() {
  if (this.variantInputs.length) {
    this.variantInputs.forEach((input) => {
      input.addEventListener('change', this.handleInputChange);
    });
  }

  if (this.quantityCards.length) {
    this.quantityCards.forEach((card) => {
      card.addEventListener('click', this.handleCardClick);
    });
  }

  // Initialize quantity from the default active card
  const activeCard = this.querySelector('.product-quantity__card--active');
  if (activeCard) {
    const quantity = activeCard.getAttribute('data-quantity');
    this.quantityInputs.forEach((input) => (input.value = quantity));
  }

  this.setButtonDataPrice();
}

  setButtonDataPrice() {
    const submitButtons = document.querySelectorAll('.product-form__submit[type="submit"]');
    if (!submitButtons.length) return;

    const activeCard = this.querySelector('.product-quantity__card--active');
    const activePrice = activeCard?.querySelector('.product-quantity__price')?.textContent || '';

    submitButtons.forEach((submitButton) => {
      const priceElement = submitButton.querySelector('[data-btn-price]');
      if (priceElement) {
        priceElement.textContent = activePrice;
      }
      submitButton.setAttribute('data-price', activePrice);
    });
  }

  handleInputChange(event) {
    const checkedInput = event.target;
    if (!checkedInput.checked) return;

    const imageUrl = checkedInput.getAttribute('data-image');
    const durationPrice = checkedInput.getAttribute('data-duration-price');
    const currency = checkedInput.getAttribute('data-currency');

    if (imageUrl) {
      this.quantityCards.forEach((card) => {
        card.querySelectorAll('.product-quantity__image img').forEach((img) => {
          img.src = imageUrl;
        });
      });
    }

    if (durationPrice && currency) {
      const pricePerUnit = parseFloat(durationPrice) / 100;
      this.quantityCards.forEach((card) => {
        const quantityValue = parseInt(card.getAttribute('data-quantity'), 10);
        let finalPrice = pricePerUnit * quantityValue;
        const priceOff = parseFloat(card.getAttribute('data-price-off')) || 0;
        if (priceOff) {
          finalPrice -= finalPrice * (priceOff / 100);
        }
        const formattedPrice = finalPrice.toFixed(2).replace('.', ',') + ' ' + currency;
        const priceElement = card.querySelector('.product-quantity__price');
        priceElement && (priceElement.textContent = formattedPrice);

        const ogPriceElement = card.querySelector('.product-quantity__og-price');
        if (ogPriceElement) {
          const originalPrice = (pricePerUnit * quantityValue).toFixed(2).replace('.', ',') + ' ' + currency;
          ogPriceElement.textContent = originalPrice;
        }
      });

      const activeQuantity = this.quantityInputs[0]?.value || '1';
      const activeCard = this.querySelector(`.product-quantity__card[data-quantity="${activeQuantity}"]`);
      const activePriceElement = activeCard?.querySelector('.product-quantity__price');
      const activePrice = activePriceElement?.textContent || '';

      this.submitSpans.forEach((span) => (span.textContent = activePrice));
      this.submitButtons.forEach((button) => button.setAttribute('data-price', activePrice));
      this.quantityCards.forEach((card) => card.classList.remove('product-quantity__card--active'));
      activeCard?.classList.add('product-quantity__card--active');

      this.updateDurationText(checkedInput);
    }

    this.updateProductsText(checkedInput);
    this.syncSubscriptionPrice();
  }

  handleCardClick(event) {
    const selectedCard = event.currentTarget;
    this.quantityCards.forEach((card) => card.classList.remove('product-quantity__card--active'));
    selectedCard.classList.add('product-quantity__card--active');

    const quantity = selectedCard.getAttribute('data-quantity');
    this.quantityInputs.forEach((input) => (input.value = quantity));

    const price = selectedCard.querySelector('.product-quantity__price')?.textContent || '';
    this.submitSpans.forEach((span) => (span.textContent = price));
    this.submitButtons.forEach((button) => button.setAttribute('data-price', price));
    this.syncSubscriptionPrice();
  }

  // Quantity/duration changes don't always sit next to a <reassurance-display>
  // (the only other thing that re-triggers this), so call it directly to keep
  // the top price and daily price in sync with the subscription discount.
  syncSubscriptionPrice() {
    document.querySelectorAll('subscribe-products').forEach((el) => {
      if (typeof el.updatePrice === 'function') el.updatePrice();
    });
  }

  updateDurationText(checkedInput) {
    const durations = [
      checkedInput.getAttribute('data-duration-1'),
      checkedInput.getAttribute('data-duration-2'),
      checkedInput.getAttribute('data-duration-3'),
    ];

    this.durationElements.forEach((el, index) => {
      durations[index] && (el.textContent = durations[index]);
    });
  }

  updateProductsText(checkedInput) {
    const unit = checkedInput.getAttribute('data-unit') || '';
    const unitMatch = unit.match(/^(\d+(?:[.,]\d+)?)\s+(.+)$/);

    document.querySelectorAll('.product-quantity__card').forEach(card => {
      const el = card.querySelector('.product-quantity__products');
      if (!el) return;
      // Variante sans contenance exploitable : on masque la ligne plutôt que de laisser celle de la variante précédente
      el.hidden = !unitMatch;
      if (!unitMatch) return;

      const unitPerBottle = parseFloat(unitMatch[1].replace(',', '.'));
      const unitLabel = unitMatch[2].trim();
      const nb = parseInt(card.getAttribute('data-quantity'), 10) || 1;
      const totalUnits = Math.round(unitPerBottle * nb * 100) / 100;
      const container = el.dataset.container || 'flacon';
      const containerLabel = nb === 1 ? container : `${container}s`;
      el.textContent = `${nb} ${containerLabel} | ${totalUnits} ${unitLabel}`;
    });
  }
}

customElements.define('quantity-single', QuantitySingle);

class QuickAddToCart extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    event.preventDefault();
    const variantId = this.closest('.product-bundle__wrapper')?.getAttribute('data-variantid');
    if (!variantId) {
      console.error('Variant ID not found');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log('Product added to cart:', data);
      })
      .catch((error) => {
        console.error('Error adding product to cart:', error);
      });
  }
}

customElements.define('quick-cart', QuickAddToCart);

class ReassuranceDisplay extends HTMLElement {
  constructor() {
    super();
    this.cards = this.querySelectorAll('.product-reassurance__card');
    this.submitButton = document.querySelector('.product-form__submit');
    this.updatePrices = this.updatePrices.bind(this);
    this.handleCardClick = this.handleCardClick.bind(this);
  }

  connectedCallback() {
    if (!this.submitButton) return;

    this.updatePrices(this.submitButton.getAttribute('data-price') || '0');

    // 1. Observe 'data-price' changes
    this.observer = new MutationObserver(() => {
      this.updatePrices(this.submitButton.getAttribute('data-price') || '0');
    });

    this.observer.observe(this.submitButton, {
      attributes: true,
      attributeFilter: ['data-price'],
    });

    // 2. Listen for variant ID changes
    const variantInput = document.querySelector('product-info .product-variant-id');
    if (variantInput) {
      this._onVariantChange = () => {
        this.updatePrices(this.submitButton.getAttribute('data-price') || '0');
      };
      variantInput.addEventListener('change', this._onVariantChange);
    }

    // 3. Listen for card click events
    this.cards.forEach((card) => {
      card.addEventListener('click', this.handleCardClick);
    });
  }

  updatePrices(price) {
    const numericPrice = parseFloat(price.replace(/[^0-9.-]/g, '')) || 0;

    const isSubscribed = document.querySelector('.product-subscribe__form-content input[type="checkbox"]')?.checked;

    if (isSubscribed) {
      const subscribeElement = document.querySelector('subscribe-products');
      if (subscribeElement && typeof subscribeElement.updatePrice === 'function') {
        subscribeElement.updatePrice();
      }
      return;
    }
    this.cards.forEach((card) => {
      const point = parseFloat(card.getAttribute('data-point')) || 0;
      const calculatedPoint = Math.floor((numericPrice * point) / 100);

      const isActive = card.classList.contains('active');
      const textTemplate = isActive ? card.getAttribute('data-large') : card.getAttribute('data-title');
      const updatedText = textTemplate.replace('[p]', calculatedPoint);

      const cardText = card.querySelector('.product-reassurance__text');
      if (cardText) cardText.textContent = updatedText;
    });
  }

  handleCardClick(event) {
    const selectedCard = event.currentTarget;
    const isActive = selectedCard.classList.contains('active');

    this.cards.forEach((card) => {
      card.classList.remove('active', 'hidden');
      card.querySelector('.product-reassurance__text').textContent = card
        .getAttribute('data-title')
        .replace(
          '[p]',
          Math.floor(
            (parseFloat(this.submitButton.getAttribute('data-price').replace(/[^0-9.-]/g, '')) *
              parseFloat(card.getAttribute('data-point'))) /
              100 || 0
          )
        );
    });

    if (!isActive) {
      selectedCard.classList.add('active');
      const point = parseFloat(selectedCard.getAttribute('data-point')) || 0;
      const calculatedPoint = Math.floor(
        (parseFloat(this.submitButton.getAttribute('data-price').replace(/[^0-9.-]/g, '')) * point) / 100
      );

      selectedCard.querySelector('.product-reassurance__text').textContent = selectedCard
        .getAttribute('data-large')
        .replace('[p]', calculatedPoint);
    } else {
      this.cards.forEach((card) => card.classList.remove('hidden'));
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();

    const variantInput = document.querySelector('product-info .product-variant-id');
    if (variantInput && this._onVariantChange) {
      variantInput.removeEventListener('change', this._onVariantChange);
    }

    this.cards.forEach((card) => {
      card.removeEventListener('click', this.handleCardClick);
    });
  }
}

customElements.define('reassurance-display', ReassuranceDisplay);

class ThumbnailSlider extends HTMLElement {
  constructor() {
    super();
    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.handleDrag = this.handleDrag.bind(this);
    this.startDrag = this.startDrag.bind(this);
    this.stopDrag = this.stopDrag.bind(this);
  }

  connectedCallback() {
    const thumbnailList = this.querySelector('.thumbnail-list');
    if (!thumbnailList) return;

    thumbnailList.addEventListener('mousedown', this.startDrag);
    thumbnailList.addEventListener('mouseleave', this.stopDrag);
    thumbnailList.addEventListener('mouseup', this.stopDrag);
    thumbnailList.addEventListener('mousemove', this.handleDrag);
  }

  startDrag(event) {
    this.isDragging = true;
    this.startX = event.clientX;
    this.startY = event.clientY;
  }

  stopDrag() {
    this.isDragging = false;
  }

  handleDrag(event) {
    if (!this.isDragging) return;

    const deltaX = event.clientX - this.startX;
    const deltaY = event.clientY - this.startY;

    this.startX = event.clientX;
    this.startY = event.clientY;

    const thumbnailList = this.querySelector('.thumbnail-list');
    thumbnailList.scrollLeft -= deltaX;
    thumbnailList.scrollTop -= deltaY;

    event.preventDefault();
  }
}

customElements.define('thumbnail-slider', ThumbnailSlider);

class SubscribeElement extends HTMLElement {
  constructor() {
    super();
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.observeRcWidget = this.observeRcWidget.bind(this);
  }

  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.choiceContainer = this.querySelector('.product-subscribe__choice');
    this.subscribeWrapper = this.querySelector('.product-subscribe__wrapper');
    this.rcWidgetContainer = document.querySelector('.recharge-subscription-widget');

    this.translations = {
      everyOne: this.getAttribute('data-every-one') || 'Toutes les 1 mois',
      everyTwo: this.getAttribute('data-every-two') || 'Toutes les 2 mois',
      everyThree: this.getAttribute('data-every-three') || 'Toutes les 3 mois',
      everyFour: this.getAttribute('data-every-four') || 'Toutes les 4 mois',
    };

    this.sectionId = this.getAttribute('data-section-id') || '';
    this.form = document.querySelector(`#product-form-${this.sectionId}`);

    this.disableCheckbox();
    this.showProductSubscribeWrapper();
    this.observeRcWidget();
    this.addEventListener('click', this.handleCheckboxClick);

    // Check selling plan from URL on initial load
    this.handleSellingPlanFromUrl();

    const pushState = history.pushState;
    history.pushState = function (...args) {
      pushState.apply(history, args);
      window.dispatchEvent(new Event('urlchange'));
    };

    const replaceState = history.replaceState;
    history.replaceState = function (...args) {
      replaceState.apply(history, args);
      window.dispatchEvent(new Event('urlchange'));
    };

    window.addEventListener('urlchange', () => {
      this.handleSellingPlanFromUrl();
    });
  }

  disableCheckbox() {
    this.checkbox && (this.checkbox.disabled = true);
  }

  enableCheckbox() {
    this.checkbox && (this.checkbox.disabled = false);
  }

  showProductSubscribeWrapper() {
    this.subscribeWrapper && (this.subscribeWrapper.style.display = 'block');
  }

  observeRcWidget() {
    if (!this.rcWidgetContainer) return;

    const observer = new MutationObserver(() => {
      const rcWidget = this.rcWidgetContainer.querySelector('.rc-widget');
      if (rcWidget) {
        this.createSubscribeDropdown();
        this.clickRcRadio2();
        this.enableCheckbox();
        observer.disconnect();
      }
    });

    observer.observe(this.rcWidgetContainer, {
      childList: true,
      subtree: true,
    });
  }

  createSubscribeDropdown() {
    const selectElement = this.rcWidgetContainer.querySelector('.rc-selling-plans-dropdown__select');
    if (!selectElement || !this.choiceContainer) return;

    const options = Array.from(selectElement.options);
    const dropdown = document.createElement('select');
    dropdown.className = 'product-subscribe__dropdown';

    options.forEach((option) => {
      const dropdownOption = document.createElement('option');
      dropdownOption.value = option.value;

      const originalText = option.textContent.trim();
      let translatedText = originalText;

      const numberMatch = originalText.match(/\d+/);
      if (numberMatch) {
        const number = numberMatch[0];

        switch (number) {
          case '1':
            translatedText = this.translations.everyOne;
            break;
          case '2':
            translatedText = this.translations.everyTwo;
            break;
          case '3':
            translatedText = this.translations.everyThree;
            break;
          case '4':
            translatedText = this.translations.everyFour;
            break;
          default:
            console.log(`No translation found for period: ${number}`);
        }
      }

      dropdownOption.textContent = translatedText;
      dropdown.appendChild(dropdownOption);
    });

    dropdown.addEventListener('change', (event) => {
      this.syncWithRcWidget(event.target.value);
      this.updateTextWithDropdownValue(event.target.options[event.target.selectedIndex].textContent.trim());
    });

    const selectDiv = this.choiceContainer.querySelector('.product-subscribe__select');
    selectDiv && this.choiceContainer.replaceChild(dropdown, selectDiv);

    const initialText = dropdown.options[dropdown.selectedIndex].textContent.trim();
    this.updateTextWithDropdownValue(initialText);
  }

  updateTextWithDropdownValue(dropdownText) {
    const textSpan = this.choiceContainer.querySelector('.product-subscribe__text');
    if (!textSpan) return;

    const dataText = textSpan.getAttribute('data-text');
    dataText && (textSpan.textContent = dataText.replace('[d]', dropdownText.toLowerCase()));
  }

  syncWithRcWidget(value) {
    const rcSelectElement = this.rcWidgetContainer.querySelector('.rc-selling-plans-dropdown__select');
    if (rcSelectElement) {
      rcSelectElement.value = value;
      rcSelectElement.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  clickRcRadio2() {
    const rcRadio2 = this.rcWidgetContainer.querySelector('#rc-radio2');
    rcRadio2 && rcRadio2.click();
  }

handleCheckboxClick(event) {
  if (event.target.closest('input[type="checkbox"]') !== this.checkbox || this.checkbox.disabled) return;

  const isActive = this.checkbox.checked;

  this.checkbox.closest('.product-subscribe__form')?.classList.toggle('choice-is-active', isActive);

  document.querySelectorAll('subscribe-products').forEach(el => {
    if (el !== this) {
      const otherCheckbox = el.querySelector('input[type="checkbox"]');
      if (otherCheckbox) otherCheckbox.checked = isActive;
      el.querySelector('.product-subscribe__form')?.classList.toggle('choice-is-active', isActive);
    }
  });

  const rcRadio1 = this.rcWidgetContainer.querySelector('#rc-radio1');
  const rcRadio2 = this.rcWidgetContainer.querySelector('#rc-radio2');
  if (rcRadio1 && rcRadio2) {
    (rcRadio1.checked ? rcRadio2 : rcRadio1).click();
  }

  this.updatePrice();
}

  updatePrice() {
    const submitButtons = document.querySelectorAll('.product-form__submit[type="submit"]');
    if (!submitButtons.length) return;

    const isSubscriptionActive = this.checkbox && this.checkbox.checked;
    const priceOff = parseFloat(this.querySelector('.product-subscribe__off')?.getAttribute('data-off')) || 0;

    const variantId = document.querySelector('product-info .product-variant-id')?.value;
    const variantPricesJson = this.getAttribute('data-raw-price');
    const variantPrices = variantPricesJson ? JSON.parse(variantPricesJson) : {};

    const parseMoney = (str) => Number((str || '').replace(/[^0-9,.-]/g, '').replace(',', '.'));

    // Read the active quantity card directly instead of trusting submitButton's
    // data-price to already be in sync — that round-trip via quantity-single is what
    // dropped the subscription discount right after a quantity change. The card's own
    // price/og-price already bake in any quantity-tier discount.
    const activeCard = document.querySelector('.product-quantity__card--active');
    const activeCardPrice = activeCard
      ? parseMoney(activeCard.querySelector('.product-quantity__price')?.textContent)
      : NaN;
    // No og-price element at all means there's no quantity-tier discount on this
    // card (parseMoney('') would otherwise return 0, not NaN, and wrongly look valid).
    const activeCardOgEl = activeCard?.querySelector('.product-quantity__og-price');
    const activeCardOgPrice = activeCardOgEl ? parseMoney(activeCardOgEl.textContent) : NaN;

    submitButtons.forEach((submitButton) => {
      let priceRaw = submitButton.getAttribute('data-raw-price');
      const regularPrice = submitButton.getAttribute('data-price');
      if (variantId && variantPrices[variantId]) {
        priceRaw = variantPrices[variantId];
      }

      if (!priceRaw && !regularPrice) return;

      let priceElementCleaned = activeCardPrice;
      if (isNaN(priceElementCleaned)) {
        const quantity = parseFloat(document.querySelector('.product-quantity')?.value) || 1;
        priceElementCleaned = regularPrice ? parseMoney(regularPrice) : parseMoney(priceRaw) * quantity;
      }
      const ogPriceCleaned = !isNaN(activeCardOgPrice) ? activeCardOgPrice : priceElementCleaned;

      if (isNaN(priceElementCleaned)) return;

      const currentCurrency = submitButton.getAttribute('data-current-currency') || '';
      const priceDisplay = submitButton.querySelector('[data-btn-price]');
      if (!priceDisplay) return;

      if (isSubscriptionActive) {
        const priceOffValue = priceElementCleaned * (priceOff / 100);
        const discountedPrice = priceElementCleaned - priceOffValue;
        const roundedUpPrice = Math.ceil(discountedPrice * 100) / 100;
        const discountedPriceFormatted = roundedUpPrice.toFixed(2).replace('.', ',') + currentCurrency;
        priceDisplay.textContent = discountedPriceFormatted;
        document.querySelectorAll('.price-dynamic').forEach(el => { el.textContent = discountedPriceFormatted; });
        this.updateDailyPrice(roundedUpPrice, ogPriceCleaned);
        this.updateSavingsBadge(roundedUpPrice, ogPriceCleaned);
        this.updateCompareAtPrice(roundedUpPrice, ogPriceCleaned);
      } else {
        const restoredPrice = regularPrice || priceRaw;
        priceDisplay.textContent = restoredPrice;
        document.querySelectorAll('.price-dynamic').forEach(el => { el.textContent = restoredPrice; });
        this.updateDailyPrice(priceElementCleaned, ogPriceCleaned);
        this.updateSavingsBadge(priceElementCleaned, ogPriceCleaned);
        this.updateCompareAtPrice(priceElementCleaned, ogPriceCleaned);
      }
    });
  }

  // Struck-through price (.compare-at-price-dynamic). Without a quantity-tier
  // discount, ogPriceCleaned equals priceElementCleaned (no og-price element
  // on the 1-unit card), so this stays hidden unless the subscription discount
  // itself creates a gap — which is what makes the 1-unit + subscribe combo
  // show its own strike-through instead of only relying on the quantity tier.
  updateCompareAtPrice(finalTotal, baseTotal) {
    const compareEls = document.querySelectorAll('.compare-at-price-dynamic');
    if (!compareEls.length || isNaN(baseTotal) || isNaN(finalTotal)) return;

    const shouldShow = baseTotal - finalTotal > 0.004;
    compareEls.forEach((el) => {
      el.innerHTML = shouldShow ? `${baseTotal.toFixed(2).replace('.', ',')} €` : '';
    });
  }

  // Quantity-tier savings badge (.savings-dynamic) only accounts for the
  // quantity discount (set by updateDynamicPrice() in custom.js). Toggling the
  // subscription changes the final price without this badge being refreshed,
  // so recompute it here against the same og price to keep it in sync.
  updateSavingsBadge(finalTotal, baseTotal) {
    const badgeEls = document.querySelectorAll('.savings-dynamic');
    if (!badgeEls.length || isNaN(baseTotal) || isNaN(finalTotal)) return;

    const savings = baseTotal - finalTotal;
    badgeEls.forEach((el) => {
      if (savings > 0.004) {
        el.innerHTML = `-${savings.toFixed(2).replace('.', ',')}€`;
        el.style.display = 'block';
      } else {
        el.innerHTML = '';
        el.style.display = 'none';
      }
    });
  }

  updateDailyPrice(finalTotal, baseTotal) {
    const dailyEls = document.querySelectorAll('.daily-dynamic span');
    const baseDaily = parseFloat(window.productData?.dailyPrice || 0);
    if (!dailyEls.length || !baseDaily || !baseTotal) return;

    const ratio = finalTotal / baseTotal;
    const daily = Math.round(baseDaily * ratio * 100) / 100;
    dailyEls.forEach((el) => {
      el.innerHTML = `soit ${daily.toFixed(2).replace('.', ',')}€/jour`;
    });
  }

  handleSellingPlanFromUrl() {
    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const sellingPlanFromUrl = urlParams.get('selling_plan');

    if (!this.form) return;

    // Check if selling_plan parameter exists in URL
    if (sellingPlanFromUrl) {
      // Check if input already exists
      let sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');

      if (!sellingPlanInput) {
        // Create new input if it doesn't exist
        sellingPlanInput = document.createElement('input');
        sellingPlanInput.setAttribute('type', 'hidden');
        sellingPlanInput.setAttribute('name', 'selling_plan');

        // Insert at the top of the form
        if (this.form.firstChild) {
          this.form.insertBefore(sellingPlanInput, this.form.firstChild);
        } else {
          this.form.appendChild(sellingPlanInput);
        }
      }

      // Update the value if it's different
      if (sellingPlanInput.value !== sellingPlanFromUrl) {
        sellingPlanInput.value = sellingPlanFromUrl;
      }
    } else {
      // Remove the input if there's no selling_plan in the URL
      const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput) {
        sellingPlanInput.remove();
      }
    }
  }
}

customElements.define('subscribe-products', SubscribeElement);
